import './src/styles/global.css';
// import '@fontsource/open-sans/latin-700.css';
import '@fontsource/raleway/latin-400.css';
import '@fontsource/raleway/latin-500.css';
import '@fontsource/raleway/latin-600.css';
import '@fontsource/raleway/latin-700.css';
import '@fontsource/raleway/latin-900.css';
import '@fontsource/poppins/latin-400.css';
import '@fontsource/poppins/latin-500.css';
import '@fontsource/poppins/latin-600.css';
import '@fontsource/poppins/latin-700.css';
import '@fontsource/poppins/latin-800.css';
import React from 'react';
import ConsentBanner from './src/components/analytics/ConsentBanner';

export const onRouteUpdate = ({ location }) => {
  if (process.env.NODE_ENV !== 'production') {
    return null;
  }

  const doNotTrack =
    typeof navigator !== 'undefined' &&
    (navigator.doNotTrack === '1' ||
      // Older IE/Edge
      // @ts-expect-error - msDoNotTrack is not in standard typings
      navigator.msDoNotTrack === '1' ||
      // Safari
      // @ts-expect-error - window.doNotTrack is not in standard typings
      (typeof window !== 'undefined' && window.doNotTrack === '1'));

  if (doNotTrack) {
    return null;
  }

  const pagePath = location ? location.pathname + location.search + location.hash : undefined;
  setTimeout(() => {
    if (typeof gtag === 'function') {
      gtag('event', 'page_view', { page_path: pagePath });
    }
  }, 100);
};

export const wrapRootElement = ({ element }) => {
  return (
    <>
      {element}
      <ConsentBanner />
    </>
  );
};
